import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";

// Components
import AppBar from "../../../components/AppBar";
import CountsCard from "../../../components/cards/Counts";
import AdminTable from "../../../components/tables/Admin";
import BreadcrumbsTitle from "../../../components/title/Breadcrumbs";
import TableTitle from "../../../components/title/Table";

// Material Icons
import SwitchAccountOutlinedIcon from "@mui/icons-material/SwitchAccountOutlined";
import { CircularProgress } from "@mui/material";
import { useAuth } from "../../../hooks/auth";

export default function AdminList() {
  const { APIClient } = useAuth();
  const [data, setData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isError, setIsError] = React.useState(false);

  React.useEffect(() => {
    if (!isError) {
      APIClient.get("/admin/alladmin")
      .then((res) => {
        setData(res.data)
        setIsLoading(false)
    })
      .catch((err) => setIsError(true))
    }
  }, [APIClient, isError]); // Empty dependency array ensures data is fetched only once

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar title="Admin List" />
      <Box
        component="main"
        sx={{
          backgroundColor: "fafafa",
          flexGrow: 1,
          overflow: "auto",
          paddingBottom: 10,
          height: "calc(100vh - 3px);",
          boxSizing: "border-box",
        }}
      >
        <Toolbar />
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <BreadcrumbsTitle text="Admin List" />
          <CountsCard
            avatar={
              <SwitchAccountOutlinedIcon
                sx={{ width: 25, height: 25 }}
                color="primary"
              />
            }
            title={"Registered Admin"}
            total={data.length.toLocaleString()}
          />
          <Card
            sx={{
              boxShadow:
                "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset;",
              p: 4,
              mt: 2,
              borderRadius: 2,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <TableTitle
                  text="Admin List"
                  action="/admin-list/add"
                  isAction={true}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                {isError ? "Error": null}
                {
                  isLoading ? <CircularProgress/> : 
                  <AdminTable data={data} />
                }
              </Grid>
            </Grid>
          </Card>
        </Container>
      </Box>
    </Box>
  );
}
